import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageTextArea } from '../../../../common/EditPage';
import { useNavigate } from 'react-router-dom';
import { getOne, create } from '../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const AccessAreasCreate = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    
    useEffect(() => {
        getOne(`/admin/access/areas/`, 'new').then(response => {
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching access area metadata: " + error.message, {});
        });
    }, []);

    const handleSave = () => {
        create(`/admin/access/areas/`, {data: data}).then(() => {
            navigate(`/admin/access/areas`);
        }).catch(error => {
            toast.error("Error creating access area: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/admin/access/areas`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageTextField 
                        label="Name" 
                        id="name" 
                        onChange={onChange} 
                        value={data.name} 
                        required
                    />
                    <EditPageTextArea 
                        label="Description" 
                        id="description" 
                        onChange={onChange} 
                        value={data.description}
                        rows={3}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default AccessAreasCreate; 